import type { SubmissionStatus } from '@/types/api/submission-status';

// Rubber-stamp status chip for the record masthead (Mensagem + Pedido).
// Bordered, letter-spaced uppercase — reads as an official stamp.
const STAMP: Record<SubmissionStatus, { label: string; icon: string; className: string }> = {
  pending: {
    label: 'Pendente',
    icon: 'schedule',
    className: 'text-secondary-dark border-secondary/50 bg-secondary/10',
  },
  handled: {
    label: 'Resolvido',
    icon: 'check_circle',
    className: 'text-tertiary border-tertiary/50 bg-tertiary/10',
  },
  dismissed: {
    label: 'Arquivado',
    icon: 'archive',
    className: 'text-on-surface-light border-line-strong bg-background',
  },
};

export function StatusStamp({ status }: { status: SubmissionStatus }) {
  const { label, icon, className } = STAMP[status] ?? {
    label: status,
    icon: 'info',
    className: 'text-on-surface-light border-line-strong bg-background',
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm border px-2 py-1 text-[10px] font-bold tracking-[0.1em] whitespace-nowrap uppercase ${className}`}
    >
      <span className="material-symbols-outlined text-[14px]">{icon}</span>
      {label}
    </span>
  );
}
